declare var process;
const server_host_local = "http://localhost:8080";
const server_host_dev = "https://dev.sensornetworks.co.za";
const server_host_qa = "https://qa.sensornetworks.co.za";
const server_host_prod = "https://production.sensornetworks.co.za";

const ionic_stage = process.env.IONIC_APP_STAGE;

const dev = {
  mode: 'Development',
  isprod: false,
  manifest: 'https://dev.plumberconnect.co.za/manifest.json',
};

const prod = {
  mode: 'Production',
  isprod: true,
  manifest: 'https://plumberconnect.co.za/manifest.json',
};

const qa = {
  mode: 'Development',
  isprod: false,
  manifest: 'https://qa.plumberconnect.co.za/manifest.json',
};

const local = {
  mode: 'Local',
  isprod: false,
  manifest: 'http://localhost:8100/manifest.json',
};


let config = qa;
let server_host = server_host_qa;
switch (ionic_stage) {
  case "local":
    server_host = server_host_local;
    config = local;
    break;
  case "dev":
    server_host = server_host_dev;
    config = dev;
    break;
  case "qa":
    server_host = server_host_qa;
    config = qa;
    break;
  case "prod":
    server_host = server_host_prod;
    config = prod;
    break;
  default:
    //
    break;
}

export const ENV = {
  ...config,
  base: server_host,
  api: server_host + '/sensordesk',
  jwtCredentialAuthority: server_host + '/credentials-authority',
  oauthAuthorizeUrl: server_host + '/credentials-authority/oauth/authorize',
  websocketServerUrl: server_host + '/connection-broker/',
  manifest2: '/manifest.json',
  ios: {
    config: {
      id: 'installer-ios-app',
      token: 'U7KjFwz9wJKCB6Ad'
    }
  },
  android: {
    config: {
      id: 'installer-android-app',
      token: 'zZr6bSGLXxo28aYk'
    }
  }
};



// WEBPACK FOOTER //
// ./src/environments/environment.ts